import Phaser from "phaser";
import { COLORS, TEXT_STYLES } from "../constants";

export type HealthBarOptions = {
  width: number;
  height?: number;
  backgroundColor?: number;
  fillColor?: number;
  borderColor?: number;
  textStyle?: Phaser.Types.GameObjects.Text.TextStyle;
};

export class HealthBar {
  private container: Phaser.GameObjects.Container;
  private background: Phaser.GameObjects.Rectangle;
  private fill: Phaser.GameObjects.Rectangle;
  private border: Phaser.GameObjects.Rectangle;
  private text: Phaser.GameObjects.Text;
  private width: number;
  private height: number;

  constructor(scene: Phaser.Scene, options: HealthBarOptions) {
    this.width = options.width;
    this.height = options.height ?? 20;

    const bgColor = options.backgroundColor ?? 0x1a1a1a;
    const fillColor =
      options.fillColor ?? Phaser.Display.Color.HexStringToColor(COLORS.healText).color;
    const borderColor = options.borderColor ?? COLORS.panelStroke;

    this.container = scene.add.container(0, 0);

    this.background = scene.add.rectangle(0, 0, this.width, this.height, bgColor, 1);
    this.background.setOrigin(0, 0);

    this.fill = scene.add.rectangle(0, 0, this.width, this.height, fillColor, 1);
    this.fill.setOrigin(0, 0);

    this.border = scene.add.rectangle(0, 0, this.width, this.height, 0x000000, 0);
    this.border.setOrigin(0, 0);
    this.border.setStrokeStyle(2, borderColor, 1);

    const textStyle = options.textStyle ?? {
      ...TEXT_STYLES.body,
      fontSize: "20px",
      color: "#ffffff",
    };
    this.text = scene.add.text(this.width / 2, this.height / 2, "", textStyle);
    this.text.setOrigin(0.5, 0.5);
    this.text.setStroke("#000000", 4);

    this.container.add(this.background);
    this.container.add(this.fill);
    this.container.add(this.border);
    this.container.add(this.text);
  }

  setHP(current: number, max: number) {
    const ratio = Math.max(0, Math.min(1, current / max));
    this.fill.width = this.width * ratio;
    this.text.setText(`${current}/${max}`);
  }

  setPosition(x: number, y: number) {
    this.container.setPosition(x, y);
  }

  getRoot(): Phaser.GameObjects.Container {
    return this.container;
  }

  destroy() {
    this.container.destroy(true);
  }
}
